module.exports = __webpack_public_path__ + "img/logo1 (2).f0a2511f.jpg";